import React from 'react';
import '../css/MainContent.css';
import '../css/AboutContent.css';

function AboutContent() {
  return (
    <div id="about-content" className="content">
      <div className="career">
        <h2>水瓜書房について</h2>
        <table>
          <tbody>
            <tr>
              <td><i>2025年 12月</i></td>
              <td>モバイルアプリ・ウェブサービス開発の個人事業として『水瓜書房』を登録</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AboutContent;
